/**
 * Helpers to decide whether a past report carries any *generated* (structured) content,
 * independent of any uploaded scan/PDF attached to it.
 *
 * Used so that a report which is ONLY an uploaded document (empty/null prescriptionData or
 * therapyReport) opens on the Uploaded view by default, and an empty Generated view isn't
 * shown at all when an Uploaded version exists for the same record.
 */

function hasNonEmptyText(value) {
  if (typeof value !== 'string') return false
  // Strip tags so an "empty" rich-text value (e.g. "<p></p>", "<br>") doesn't count as content.
  return value.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim().length > 0
}

function hasItems(value) {
  return Array.isArray(value) && value.length > 0
}

/**
 * True when the prescriptionData has at least one data-bearing field populated.
 * Mirrors the section-has-data signals used by the view-only renderer (drugs, complaints,
 * diagnosis, observation, advice, investigations, therapies, instructions, assessments,
 * free-form notes, vitals).
 */
export function hasMeaningfulPrescriptionData(prescriptionData) {
  const pd = prescriptionData
  if (!pd || typeof pd !== 'object') return false
  return (
    hasItems(pd.drugInfoList) ||
    hasItems(pd.complaints) ||
    hasItems(pd.diagnosis) ||
    hasItems(pd.investigations) ||
    hasItems(pd.therapiesNeeded) ||
    hasItems(pd.prescriptionAdvices) ||
    hasItems(pd.guidanceAndAdvices) ||
    hasItems(pd.healthInstructions) ||
    hasItems(pd.instructions) ||
    hasItems(pd.prescribedAssessments) ||
    hasItems(pd.psychAssessments) ||
    hasNonEmptyText(pd.observation) ||
    hasNonEmptyText(pd.observations) ||
    hasNonEmptyText(pd.advice) ||
    hasItems(pd.advice) ||
    hasNonEmptyText(pd.freeFormRichText) ||
    hasNonEmptyText(pd.content) ||
    Boolean(pd.suggestedBookingTherapy) ||
    Boolean(pd.vital)
  )
}
